{
  "styles": {
    "models": {
      "resetHeight": "Höhe zurücksetzen",
      "resetLength": "Länge zurücksetzen",
      "resetWidth": "Breite zurücksetzen",
      "attributeModel": "Bearbeiten Sie Ihr 3D-Modell, indem Sie das Modell und die Abmessungen ändern",
      "attributeDimensions": "Bearbeiten Sie Ihr 3D-Modell, indem Sie die Abmessungen ändern",
      "determineModel": "Ermitteln Sie das Modell durch",
      "determineDimensions": "Ermitteln Sie Länge, Breite und Höhe durch"
    }
  },
  "exports": {
    "legendPosition": "Position der Legende",
    "top": "Oben",
    "bottom": "Unterseite",
    "left": "Links",
    "right": "Rechts",
    "layers": "Schichten",
    "all": "Alle",
    "custom": "Benutzerdefiniert",
    "selectLayers": "Wählen Sie die zu exportierenden Ebenen aus",
    "selected": "ausgewählt",
    "hidden": "(Versteckt)",
    "none": "Keine"
  },
  "get_map_errors": {
    "default": "Etwas ist schief gelaufen",
    "not_found": "Plan wurde nicht gefunden",
    "click_here_to_browser_maps": "Klicken Sie hier, um die Pläne zu durchsuchen"
  },
  "add_list_item_attribute": {
    "title": "Spalte hinzufügen",
    "subtitle": "Bearbeiten Sie dieses Attribut anhand der folgenden Felder nach Ihren Anforderungen",
    "column_name": "Name der Spalte",
    "column_type": "Spaltentyp",
    "type": "Art der Immobilie"
  },
  "list_item_properties": {
    "additional_properties": "Zusätzliche Eigenschaften"
  },
  "contextMenu": {
    "import": "Importieren",
    "export": "Exportieren",
    "copy_layer": "Ebene {{ pluralise }} kopieren",
    "copy_group": "Gruppe {{ pluralise }} kopieren",
    "copy_layer_and_group": "Kopiere die Ebene {{ pluraliseLayers }} und gruppiere {{ pluraliseGroups }}",
    "delete": "Löschen",
    "delete_layers_title": "Ebenen löschen",
    "delete_layers_description": "Eine oder mehrere Ebenen, die Sie löschen möchten, sind mit einer anderen Karte verknüpft. Sie werden aus dieser Karte entfernt und Sie können sie jederzeit erneut verknüpfen."
  },
  "copyOrUnlinkLayers": {
    "copy": "Kopieren",
    "unlink": "Verknüpfung aufheben",
    "copying_layers": "Ebenen kopieren",
    "unlink_layer": "Verknüpfung einer Ebene aufheben",
    "linked_layers": "Verknüpfte Ebenen",
    "original_plan": "Ursprünglicher Plan",
    "helpbase_blurb": {
      "click": "Klicken Sie hier",
      "link": "Erste Schritte - Knowledge Base (iventis.com)",
      "further_info": "für weitere Informationen."
    },
    "copy_blurb": {
      "are_you_sure": "Bist du sicher, dass du kopieren willst",
      "this": "diese",
      "these": "diese",
      "layer": "Ebene {{ pluralise }}",
      "group": "Gruppe {{ pluralise }}",
      "layers_and_groups": "Ebenen und Gruppen"
    },
    "unlink_info": {
      "links_to": "Diese Ebene ist verknüpft mit",
      "changes_not_reflected": "Indem Sie die Verknüpfung mit dem ursprünglichen Plan aufheben, erstellen Sie eine Kopie. Alle an der ursprünglichen Ebene vorgenommenen Änderungen wirken sich nicht mehr auf Ihren Plan aus."
    },
    "unlink_blurb": "Sie kopieren Ebenen, die mit verschiedenen Karten verknüpft sind. Indem Sie die Verknüpfung mit dem ursprünglichen Plan aufheben, erstellen Sie eine Kopie. Alle an der ursprünglichen Ebene vorgenommenen Änderungen wirken sich nicht mehr auf Ihren Plan aus.",
    "copy_with_map_objects": "Kopiere die Ebene {{ pluralise }} mit Kartenobjekten"
  },
  "shareMap": {
    "title": "Plan teilen",
    "share_with_team": "Mit dem Team teilen",
    "share_with_team_details": "Teilen Sie den Plan mit den Teammitgliedern, indem Sie ihn in den „Team-Arbeitsbereich“ verschieben",
    "shared_library": {
      "title": "Datei mit dem Team teilen",
      "footer": "Teammitglieder können die Datei schreibgeschützt ansehen"
    },
    "shared_link": {
      "title": "Link teilen"
    },
    "share_link": "Link generieren",
    "share_link_details": "Erstellen Sie einen temporären, schreibgeschützten Link, um diesen Plan mit Benutzern zu teilen, die keinen Zugang zu Iventis haben",
    "share_link_generated": "Dieser Link läuft in {{ numberOfDays }} Tagen ab. Sie können jederzeit einen neuen Link generieren."
  },
  "defaultAttribute": {
    "add": "Fügen Sie einen Standardwert für das Attribut hinzu",
    "default_field_type": "Standardwert {{ dataFieldType }}",
    "tickbox": {
      "label": "Standardstatus der Checkbox",
      "on": "EIN",
      "off": "AUS"
    }
  },
  "fileUpload": {
    "import_title": "Daten in die Karte importieren",
    "drop_file": "Datei zum Hochladen ablegen",
    "supported_extensions": "Unterstützte Erweiterungen",
    "contact_support": "Kontaktieren Sie den Support für größere Dateien und andere Erweiterungen",
    "choose_file": "Wählen Sie eine Datei",
    "max_file_size": "Maximale Dateigröße {{ maxFileSize }} MB"
  }
}